import component from "./CheckoutInfo";

export default component;
